import React from 'react';

import { Popper, PopperPlacementType, PopperProps } from '../../../Popper/Popper';

export const PopperAdapter: (placement?: PopperPlacementType) => React.FC<React.PropsWithChildren<PopperProps>> =
  (placement) => (props) => <Popper {...props} placement={placement} />;
